module.exports = __webpack_public_path__ + "media/images/logo-f2ceee4c.png";